import React, { useState, useEffect } from 'react'
// import { Container, Row, Col, Form, Button } from 'react-bootstrap'
import styled from 'styled-components'
// import get from 'lodash/get'
// import axios from 'axios'
 

// INTEGRATION FLOW
// (1) fill out form - I believe this will come from Hover, but we'll probably need to custom code it so that we can send the info to Zapier
// (1.a) form info --> Zapier --> Acculynx, triggering Acculynx notification to sales that "Step 1 Completed - filled out form for interest in Hover"
// (1.b.1) hover sends email to user telling them to download app and submit pictures
//   --report email sent to user
//   --if possible to send report email to CSR as well, then continue to 1.b.2 
// (1.b.2) report info from email --> Zapier --> Acculynx, triggering Acculynx notification to sales that "Step 2 Completed - prospect completed Hover home estimate"


const Wrap = styled.div`
 
`

const HoverLP = props => {
  // const [formSubmitted, setFormSubmitted] = useState(false);
  // const [formData, setFormData] = useState({
  //   userName: "",
  //   email: "",
  // })
  // const handleChange = (e) => {
  //   const data = { ...formData };
  //   data[e.target.name] = e.target.value;
  //   setFormData(data);
  // }
  // const handleSubmit = (e) => {
  //   fetch("/", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //     body: encode({ "form-name": "Hover LP Form", ...formData }),
  //   })
  //     .then((response) => console.log('response: ', response))
  //     .catch((error) => console.log("error: ", error))
  //     .then(() => console.log('encoded data: ', encode({ "form-name": "Hover LP Form", ...formData })))

  //   e.preventDefault();
  //   setFormSubmitted(true);
  // }
  // const encode = (data) => {
  //   return Object.keys(data)
  //     .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
  //     .join("&");
  // };
  
  return (
    <Wrap>
      hover lp - currently in testing for integrations
      <br />
      <br />
      <form name="Hover LP Form" netlify>
        <input type="text" name="userName" placeholder="name" />
        <input type="email" name="email" placeholder="email" />
        <input type="submit" value="submit"/>
      </form>
      {/* <Form 
        name="Hover LP Form"
        onSubmit={handleSubmit} 
        // method="POST"
        data-netlify="true"         
      >
        <Form.Control 
          required
          type="text" 
          name="userName"                     
          value={formData.name}
          onChange={handleChange} 
          placeholder="Name" 
        />
        <Form.Control 
          required
          type="email" 
          name="email"                      
          value={formData.email}
          onChange={handleChange} 
          placeholder="Email" 
        />
        <Button type="submit">
          Submit
        </Button>
      </Form> */}
    </Wrap>
  )
}
 
export default HoverLP




// EXAMPLE OF WORKING GET TO PULL A JOB'S DETAILS (NOT MEASUREMENT/ESTIMATE REPORT) FROM HOVER (USING KENNAN'S HOVER SANDBOX ACCOUNT AUTH INFO)
// axios({
//   method: 'get',
//   url: 'https://sandbox.hover.to/api/v2/jobs/24526',
//   headers: {
//     'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOnsib3JnX2lkIjo2MjR9LCJkYXRhIjp7ImFwcGxpY2F0aW9uX2lkIjo0MDJ9LCJleHAiOjE2MjA4Mzc4Mjd9.3YkO-b4w0ygqIstttSnD04hR34jvzFVGFLKgoPdoZcU',
//     'client_id': 'e844d492211755693f02a4b3be228ffa4641a0b073f52af6e1f49aaa9507c179',
//     'client_secret': '71de9480fb44566383e91df69c5a83069cb8e9b6778af028520ce0382f57296ad6703022a63b3bfedea6927f422384c4677e460c652c3da5fa264bec890120bc',
//     'callback_url': 'https://geo.coloradosidingrepair.com/hover',
//   }
// })
// .then(response => {
//   console.log('response: ', response); 
// })
// .catch(error => {
//   console.log('error: ', error);
// })


// FAILED FORM SUBMIT POST FUNCTIONS

  // axios({
  //   method: 'post',
  //   url: 'https://sandbox.hover.to/api/v1/jobs',
  //   data: {
  //     customer_name: formData.name,
  //     user_name: formData.email,
  //     org_name: "Colorado Siding Repair",
  //   },
  //   headers: {
  //     'Access-Control-Allow-Origin': '*',
  //     'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOnsib3JnX2lkIjo2MjR9LCJkYXRhIjp7ImFwcGxpY2F0aW9uX2lkIjo0MDJ9LCJleHAiOjE2MjA4Mzc4Mjd9.3YkO-b4w0ygqIstttSnD04hR34jvzFVGFLKgoPdoZcU',
  //     'client_id': 'e844d492211755693f02a4b3be228ffa4641a0b073f52af6e1f49aaa9507c179',
  //     'client_secret': '71de9480fb44566383e91df69c5a83069cb8e9b6778af028520ce0382f57296ad6703022a63b3bfedea6927f422384c4677e460c652c3da5fa264bec890120bc',
  //     'callback_url': 'https://geo.coloradosidingrepair.com/hover',
  //   }
  // })
  // .then(response => console.log('response: ', response))
  // .catch(error => console.log('error: ', error))

  // fetch("https://sandbox.hover.to/api/v1/jobs", {
  //   method: "POST",
  //   headers: { 
  //     'Access-Control-Allow-Origin': '*',
  //     'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOnsib3JnX2lkIjo2MjR9LCJkYXRhIjp7ImFwcGxpY2F0aW9uX2lkIjo0MDJ9LCJleHAiOjE2MjA4Mzc4Mjd9.3YkO-b4w0ygqIstttSnD04hR34jvzFVGFLKgoPdoZcU',
  //     'client_id': 'e844d492211755693f02a4b3be228ffa4641a0b073f52af6e1f49aaa9507c179',
  //     'client_secret': '71de9480fb44566383e91df69c5a83069cb8e9b6778af028520ce0382f57296ad6703022a63b3bfedea6927f422384c4677e460c652c3da5fa264bec890120bc',
  //     'callback_url': 'https://geo.coloradosidingrepair.com/hover', 
  //   },
  //   body: { 
  //     customer_name: formData.name,
  //     user_name: formData.email,
  //     org_name: "Colorado Siding Repair",
  //   },
  // })
  //   .then((response) => console.log(response))
  //   .catch((error) => console.log(error));
  // e.preventDefault();
  // setFormSubmitted(true);